import type { JSX } from 'react';

import { FacebookRegularIcon as FacebookIcon, RedditIcon } from '@change/ds-icons';

import { Chip, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

type ChipsContainerProps = {
	activeFilter: 'all' | 'reddit' | 'facebook';
	onFilterClick: (platform: 'all' | 'reddit' | 'facebook') => void;
	showChips: boolean;
};

export function ChipsContainer({ activeFilter, onFilterClick, showChips }: ChipsContainerProps): JSX.Element | null {
	if (!showChips) {
		return null;
	}

	return (
		<div className="flex flex-row gap-3" data-testid="platform-chips" data-qa="platform-chips">
			<Chip
				data-testid="all-chip"
				data-qa="all-chip"
				as="button"
				size="small"
				onClick={() => onFilterClick('all')}
				active={activeFilter === 'all'}
				data-active={activeFilter === 'all' ? 'true' : 'false'}
			>
				<Text>
					<Translate value="corgi.petition.starter_dashboard_v2.recommendations.all.chip_title" />
				</Text>
			</Chip>
			<Chip
				data-testid="reddit-chip"
				data-qa="reddit-chip"
				as="button"
				size="small"
				onClick={() => onFilterClick('reddit')}
				active={activeFilter === 'reddit'}
				data-active={activeFilter === 'reddit' ? 'true' : 'false'}
			>
				<div className="flex items-center justify-center gap-1.5">
					<div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF6A33] text-white">
						<RedditIcon size="x-small" />
					</div>
					<Text>
						<Translate value="corgi.petition.starter_dashboard_v2.recommendations.reddit.chip_title" />
					</Text>
				</div>
			</Chip>
			<Chip
				data-testid="facebook-chip"
				data-qa="facebook-chip"
				as="button"
				size="small"
				onClick={() => onFilterClick('facebook')}
				active={activeFilter === 'facebook'}
				data-active={activeFilter === 'facebook' ? 'true' : 'false'}
			>
				<div className="flex items-center justify-center gap-1.5">
					<div className="flex h-6 w-6 items-center justify-center rounded-full text-[#1877F2]">
						<FacebookIcon size="medium" />
					</div>
					<Text>
						<Translate value="corgi.petition.starter_dashboard_v2.recommendations.facebook.chip_title" />
					</Text>
				</div>
			</Chip>
		</div>
	);
}
